export default "__VITE_ASSET__C$c2PmfU__"